export const translations = {
  en: {
    nav: {
      home: 'Home',
      about: 'About Us',
      locations: 'Our Locations',
      menu: 'Menu',
      gallery: 'Gallery',
      reviews: 'Reviews',
      reservations: 'Reservations',
    },
    hero: {
      headline: 'Authentic Sinaloa Seafood in Los Cabos',
      subheadline: 'Fresh mariscos and sushi straight from Sinaloa — where every dish tells a story of tradition and the sea.',
      viewMenu: 'View Menu',
      reserve: 'Reserve via WhatsApp',
    },
    about: {
      tagline: 'Our Story',
      title: 'The Taste of Sinaloa, Right Here in Los Cabos',
      description: 'At Cristian\'s Baja Salada, we bring the authentic flavors of Sinaloa to the heart of Los Cabos. Our mariscos and sushi are crafted with 100% fresh, premium ingredients — from our signature aguachiles to our perfectly prepared ceviches, seafood cocktails, and creative sushi rolls.',
      description2: 'Known as the best mariscos and sushi in Los Cabos, our restaurants offer a vibrant, modern atmosphere perfect for families, couples, and groups of friends. Whether you\'re a local or visiting paradise, we invite you to experience the bold, unforgettable taste of Sinaloa.',
      seoContent1: 'Looking for the best mariscos and sushi in Los Cabos? Cristian\'s Baja Salada serves fresh seafood prepared daily using traditional Sinaloa recipes passed down through generations. Our skilled chefs transform the freshest catches into mouthwatering dishes that capture the essence of coastal Mexican cuisine.',
      seoContent2: 'Our three convenient locations across Cabo San Lucas and Los Cabos make it easy for tourists and locals alike to enjoy authentic Sinaloa style mariscos and sushi. From our famous shrimp cocktails to our signature zarandeado fish and creative sushi rolls, every plate showcases the quality and passion that has made us a top-rated seafood restaurant in the region.',
      seoHeading1: 'Fresh Sinaloa Style Mariscos & Sushi',
      quality: 'Premium Quality',
      qualityDesc: '100% fresh, sustainably sourced seafood prepared daily with authentic Sinaloa recipes.',
      tradition: 'Sinaloa Tradition',
      traditionDesc: 'Generations of culinary heritage brought to your table with love and passion.',
      family: 'Family Friendly',
      familyDesc: 'A warm, welcoming atmosphere perfect for families, celebrations, and special moments.',
    },
    locations: {
      tagline: 'Visit Us',
      title: 'Mariscos & Sushi in Los Cabos',
      subtitle: 'Three locations serving fresh Sinaloa style mariscos and sushi across Cabo San Lucas',
      seoSubtitle: 'Find the best mariscos and sushi restaurant near you in Los Cabos',
      hours: 'Hours',
      hoursValue: 'Daily 12:00 PM – 10:00 PM',
      call: 'Call Now',
      whatsapp: 'Reserve via WhatsApp',
      getDirections: 'Get Directions',
    },
    menu: {
      tagline: 'Our Menu',
      title: 'Mariscos & Sushi in Cabo San Lucas',
      subtitle: 'Authentic Sinaloa style mariscos, sushi, ceviche, aguachile and more',
      downloadPdf: 'Download Full Menu (PDF)',
      signature: 'Signature Dish',
      categories: {
        mariscos: 'Mariscos',
        sushi: 'Sushi',
        aguachiles: 'Aguachiles',
        tostadas: 'Tostadas',
        specials: 'Specials',
      },
    },
    gallery: {
      tagline: 'Gallery',
      title: 'Fresh Mariscos & Sushi Los Cabos',
      subtitle: 'Explore our Sinaloa style mariscos, sushi dishes and restaurant ambiance',
    },
    reviews: {
      tagline: 'Reviews',
      title: 'Best Mariscos & Sushi in Cabo',
      subtitle: 'Rated #1 for mariscos and sushi in Los Cabos by guests on Google and TripAdvisor',
      googleReviews: 'Google Reviews',
      tripAdvisor: 'TripAdvisor',
      basedOn: 'Based on',
      reviewsText: 'reviews',
      readGoogle: 'Read Reviews on Google',
      readTripadvisor: 'Read Reviews on TripAdvisor',
      verifiedReviews: 'Verified Reviews',
      trustSubtitle: 'Our guests consistently rate us as the top mariscos and sushi destination in Los Cabos across all major review platforms.',
    },
    reservations: {
      tagline: 'Reservations',
      title: 'Reserve Your Table',
      subtitle: 'Join us for an unforgettable dining experience. Reserve easily via WhatsApp or fill out the form below.',
      whatsappTitle: 'Quick Reservation via WhatsApp',
      whatsappDesc: 'The fastest way to reserve your table. Send us a message and we\'ll confirm your booking instantly.',
      whatsappButton: 'Reserve on WhatsApp',
      formTitle: 'Or Fill Out the Form',
      name: 'Your Name',
      date: 'Preferred Date',
      time: 'Preferred Time',
      partySize: 'Party Size',
      message: 'Special Requests (optional)',
      submit: 'Send Reservation Request',
      success: 'Reservation request sent! We\'ll confirm via WhatsApp.',
      person: 'person',
      persons: 'persons',
    },
    social: {
      tagline: 'Follow Us',
      title: 'Stay Connected',
      subtitle: 'Follow us on social media for daily specials, behind-the-scenes content, and more',
    },
    footer: {
      description: 'Cristian\'s Baja Salada - Authentic Sinaloa style mariscos and sushi in Los Cabos. Best seafood restaurant in Cabo San Lucas with three locations.',
      quickLinks: 'Quick Links',
      contact: 'Contact',
      followUs: 'Follow Us',
      rights: '© 2025 Cristian\'s Baja Salada. All rights reserved.',
      madeWith: 'Best Mariscos & Sushi in Los Cabos',
    },
  },
  es: {
    nav: {
      home: 'Inicio',
      about: 'Sobre Nosotros',
      locations: 'Nuestras Ubicaciones',
      menu: 'Menú',
      gallery: 'Galería',
      reviews: 'Reseñas',
      reservations: 'Reservaciones',
    },
    hero: {
      headline: 'Mariscos y Sushi Auténticos de Sinaloa en Los Cabos',
      subheadline: 'Mariscos y sushi frescos directo de Sinaloa — donde cada platillo cuenta una historia de tradición y mar.',
      viewMenu: 'Ver Menú',
      reserve: 'Reservar por WhatsApp',
    },
    about: {
      tagline: 'Nuestra Historia',
      title: 'El Sabor de Sinaloa, Aquí en Los Cabos',
      description: 'En Cristian\'s Baja Salada, traemos los sabores auténticos de Sinaloa al corazón de Los Cabos. Nuestros mariscos y sushi están elaborados con ingredientes 100% frescos y premium — desde nuestros aguachiles insignia hasta nuestros ceviches, cócteles de mariscos y creativos rollos de sushi.',
      description2: 'Reconocidos como los mejores mariscos y sushi en Los Cabos, nuestros restaurantes ofrecen un ambiente vibrante y moderno perfecto para familias, parejas y grupos de amigos. Ya seas local o estés visitando el paraíso, te invitamos a experimentar el sabor audaz e inolvidable de Sinaloa.',
      seoContent1: '¿Buscas los mejores mariscos y sushi en Los Cabos? Cristian\'s Baja Salada sirve mariscos frescos preparados diariamente usando recetas tradicionales de Sinaloa transmitidas por generaciones. Nuestros expertos chefs transforman las capturas más frescas en platillos deliciosos que capturan la esencia de la cocina costera mexicana.',
      seoContent2: 'Nuestras tres convenientes ubicaciones en Cabo San Lucas y Los Cabos facilitan que turistas y locales disfruten de auténticos mariscos y sushi estilo Sinaloa. Desde nuestros famosos cócteles de camarón hasta nuestro emblemático pescado zarandeado y creativos rollos de sushi, cada platillo muestra la calidad y pasión que nos ha convertido en el restaurante de mariscos mejor calificado de la región.',
      seoHeading1: 'Mariscos y Sushi Frescos Estilo Sinaloa',
      quality: 'Calidad Premium',
      qualityDesc: 'Mariscos 100% frescos, de origen sustentable, preparados diariamente con recetas auténticas de Sinaloa.',
      tradition: 'Tradición Sinaloense',
      traditionDesc: 'Generaciones de herencia culinaria llevadas a tu mesa con amor y pasión.',
      family: 'Para Toda la Familia',
      familyDesc: 'Un ambiente cálido y acogedor perfecto para familias, celebraciones y momentos especiales.',
    },
    locations: {
      tagline: 'Visítanos',
      title: 'Mariscos y Sushi en Los Cabos',
      subtitle: 'Tres ubicaciones sirviendo mariscos y sushi frescos estilo Sinaloa en Cabo San Lucas',
      seoSubtitle: 'Encuentra el mejor restaurante de mariscos y sushi cerca de ti en Los Cabos',
      hours: 'Horario',
      hoursValue: 'Diario 12:00 PM – 10:00 PM',
      call: 'Llamar Ahora',
      whatsapp: 'Reservar por WhatsApp',
      getDirections: 'Cómo Llegar',
    },
    menu: {
      tagline: 'Nuestro Menú',
      title: 'Mariscos y Sushi en Cabo San Lucas',
      subtitle: 'Auténticos mariscos y sushi estilo Sinaloa, ceviche, aguachile y más',
      downloadPdf: 'Descargar Menú Completo (PDF)',
      signature: 'Platillo Insignia',
      categories: {
        mariscos: 'Mariscos',
        sushi: 'Sushi',
        aguachiles: 'Aguachiles',
        tostadas: 'Tostadas',
        specials: 'Especiales',
      },
    },
    gallery: {
      tagline: 'Galería',
      title: 'Mariscos y Sushi Frescos Los Cabos',
      subtitle: 'Explora nuestros platillos de mariscos, sushi estilo Sinaloa y el ambiente del restaurante',
    },
    reviews: {
      tagline: 'Reseñas',
      title: 'Mejores Mariscos y Sushi en Cabo',
      subtitle: 'Calificado #1 en mariscos y sushi en Los Cabos por visitantes en Google y TripAdvisor',
      googleReviews: 'Reseñas de Google',
      tripAdvisor: 'TripAdvisor',
      basedOn: 'Basado en',
      reviewsText: 'reseñas',
      readGoogle: 'Leer Reseñas en Google',
      readTripadvisor: 'Leer Reseñas en TripAdvisor',
      verifiedReviews: 'Reseñas Verificadas',
      trustSubtitle: 'Nuestros invitados consistentemente nos califican como el destino de mariscos y sushi número uno en Los Cabos en todas las principales plataformas de reseñas.',
    },
    reservations: {
      tagline: 'Reservaciones',
      title: 'Reserva Tu Mesa',
      subtitle: 'Únete a nosotros para una experiencia gastronómica inolvidable. Reserva fácilmente por WhatsApp o llena el formulario.',
      whatsappTitle: 'Reservación Rápida por WhatsApp',
      whatsappDesc: 'La forma más rápida de reservar tu mesa. Envíanos un mensaje y confirmaremos tu reservación al instante.',
      whatsappButton: 'Reservar por WhatsApp',
      formTitle: 'O Llena el Formulario',
      name: 'Tu Nombre',
      date: 'Fecha Preferida',
      time: 'Hora Preferida',
      partySize: 'Número de Personas',
      message: 'Solicitudes Especiales (opcional)',
      submit: 'Enviar Solicitud de Reservación',
      success: '¡Solicitud de reservación enviada! Confirmaremos por WhatsApp.',
      person: 'persona',
      persons: 'personas',
    },
    social: {
      tagline: 'Síguenos',
      title: 'Mantente Conectado',
      subtitle: 'Síguenos en redes sociales para ofertas diarias, contenido detrás de cámaras y más',
    },
    footer: {
      description: 'Cristian\'s Baja Salada - Mariscos y sushi auténticos estilo Sinaloa en Los Cabos. Mejor restaurante de mariscos en Cabo San Lucas con tres ubicaciones.',
      quickLinks: 'Enlaces Rápidos',
      contact: 'Contacto',
      followUs: 'Síguenos',
      rights: '© 2025 Cristian\'s Baja Salada. Todos los derechos reservados.',
      madeWith: 'Mejores Mariscos y Sushi en Los Cabos',
    },
  },
};

export const WHATSAPP_NUMBER = '+526243582926';
export const WHATSAPP_LINK = 'https://wa.me/5216243582926';

export const locationData = [
  {
    id: 1,
    name: 'El Tezal',
    phone: '+52 624 358 2926',
    phoneClean: '+526243582926',
    whatsappLink: 'https://wa.me/5216243582926',
    description: {
      en: 'Located in one of the most privileged areas of Los Cabos, our El Tezal branch offers beautiful views and unforgettable sunsets that elevate the entire dining experience. It is the perfect place to enjoy authentic Sinaloa style seafood in a modern, relaxed and family friendly atmosphere. Ideal for sharing a special meal while the sky transforms at sunset.',
      es: 'Ubicada en una de las zonas más privilegiadas de Los Cabos, nuestra sucursal El Tezal ofrece hermosas vistas y atardeceres inolvidables que elevan toda la experiencia gastronómica. Es el lugar perfecto para disfrutar mariscos auténticos estilo Sinaloa en un ambiente moderno, relajado y familiar. Ideal para compartir una comida especial mientras el cielo se transforma al atardecer.',
    },
    mapsLink: 'https://maps.app.goo.gl/iQmC7Pb9zAgpFKUe8',
    mapEmbed: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3671.5!2d-109.88!3d22.90!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x86af4b0db3e5b5e7%3A0x1!2sEl+Tezal%2C+Cabo+San+Lucas!5e0!3m2!1sen!2smx!4v1700000000000!5m2!1sen!2smx',
    image: '/assets/images/locations/el-tezal-new.jpg',
  },
  {
    id: 2,
    name: 'Centro Los Cabos',
    phone: '+52 624 161 1116',
    phoneClean: '+526241611116',
    whatsappLink: 'https://wa.me/5216241611116',
    description: {
      en: 'Located in the heart of Los Cabos, our Centro branch is the perfect meeting point for both locals and visitors. With a strategic central location and easy access, this space blends the energy of the city with the authentic flavors of Sinaloa. Perfect for those looking for fresh seafood in a vibrant and convenient area.',
      es: 'Ubicada en el corazón de Los Cabos, nuestra sucursal Centro es el punto de encuentro perfecto tanto para locales como visitantes. Con una ubicación central estratégica y fácil acceso, este espacio fusiona la energía de la ciudad con los sabores auténticos de Sinaloa. Perfecto para quienes buscan mariscos frescos en una zona vibrante y conveniente.',
    },
    mapsLink: 'https://maps.app.goo.gl/oQ6t4QXtLsjxGfw19',
    mapEmbed: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3671.8!2d-109.9124!3d22.8905!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x86af4b0db3e5b5e7%3A0x2!2sCentro%2C+Cabo+San+Lucas!5e0!3m2!1sen!2smx!4v1700000000000!5m2!1sen!2smx',
    image: '/assets/images/locations/centro.png',
  },
  {
    id: 3,
    name: 'Carretera Transpeninsular',
    phone: '+52 624 145 9815',
    phoneClean: '+526241459815',
    whatsappLink: 'https://wa.me/5216241459815',
    hours: {
      en: 'Daily 10:00 AM – 6:00 PM',
      es: 'Diario 10:00 AM – 6:00 PM',
    },
    whatsappText: {
      en: 'Place Order',
      es: 'Hacer Pedido',
    },
    description: {
      en: 'Our branch on the Transpeninsular Highway offers the traditional experience of seafood prepared fresh to order and customized to each guest\'s preference. Inspired by the authentic Sinaloa street style seafood concept, every dish is served fresh with bold flavor and personalized attention. Ideal for those seeking real taste, quality and freshness in every bite.',
      es: 'Nuestra sucursal en la Carretera Transpeninsular ofrece la experiencia tradicional de mariscos preparados frescos al momento y personalizados al gusto de cada comensal. Inspirada en el auténtico concepto de mariscos de carreta estilo Sinaloa, cada platillo se sirve al instante, con ese sabor audaz y característico que distingue a la cocina sinaloense. Ideal para quienes buscan sabor real, calidad y frescura en cada bocado.',
    },
    mapsLink: 'https://maps.app.goo.gl/xWMQdGPKLy8sH3Fi6',
    mapEmbed: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3674.5!2d-109.75!3d23.05!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x86af5108b5c5b5e7%3A0x3!2sCarretera+Transpeninsular%2C+Los+Cabos!5e0!3m2!1sen!2smx!4v1700000000000!5m2!1sen!2smx',
    image: '/assets/images/locations/carretera-new.jpg',
  },
];

export const menuData = {
  mariscos: [
    { id: 1, name: { en: 'Shrimp Cocktail Sinaloa', es: 'Cóctel de Camarón Sinaloa' }, description: { en: 'Fresh gulf shrimp in our house tomato-lime broth with avocado, cilantro, and serrano pepper', es: 'Camarón fresco del golfo en nuestro caldo de tomate-limón con aguacate, cilantro y chile serrano' }, price: '$220', signature: true },
    { id: 2, name: { en: 'Grilled Lobster Tail', es: 'Cola de Langosta a la Parrilla' }, description: { en: 'Butter-basted lobster tail grilled to perfection, served with garlic rice and seasonal vegetables', es: 'Cola de langosta bañada en mantequilla a la parrilla, servida con arroz al ajo y verduras de temporada' }, price: '$650', signature: false },
    { id: 3, name: { en: 'Zarandeado Fish', es: 'Pescado Zarandeado' }, description: { en: 'Whole butterflied fish marinated in Sinaloa-style adobo, grilled over mesquite charcoal', es: 'Pescado mariposa marinado en adobo estilo Sinaloa, asado sobre carbón de mezquite' }, price: '$380', signature: true },
    { id: 4, name: { en: 'Seafood Platter for Two', es: 'Torre de Mariscos para Dos' }, description: { en: 'A generous tower of shrimp, octopus, fish, oysters, and crab with three dipping sauces', es: 'Una generosa torre de camarón, pulpo, pescado, ostiones y jaiba con tres salsas' }, price: '$580', signature: false },
  ],
  sushi: [
    { id: 5, name: { en: 'Baja Roll', es: 'Rollo Baja' }, description: { en: 'Tempura shrimp, cream cheese, avocado, topped with fresh tuna and spicy mayo', es: 'Camarón tempura, queso crema, aguacate, cubierto con atún fresco y mayonesa picante' }, price: '$280', signature: true },
    { id: 6, name: { en: 'Sinaloa Dragon Roll', es: 'Rollo Dragón Sinaloa' }, description: { en: 'Crispy shrimp roll topped with grilled eel, avocado, and our secret chipotle glaze', es: 'Rollo de camarón crujiente cubierto con anguila asada, aguacate y nuestro glaseado secreto de chipotle' }, price: '$320', signature: false },
    { id: 7, name: { en: 'Cabo Sunset Roll', es: 'Rollo Atardecer de Cabo' }, description: { en: 'Salmon, mango, and jalapeño inside, topped with yellowtail and ponzu citrus drizzle', es: 'Salmón, mango y jalapeño por dentro, cubierto con jurel y reducción de ponzu cítrico' }, price: '$290', signature: false },
  ],
  aguachiles: [
    { id: 8, name: { en: 'Classic Green Aguachile', es: 'Aguachile Verde Clásico' }, description: { en: 'Raw shrimp cured in serrano-lime juice with cucumber, red onion, and fresh cilantro', es: 'Camarón crudo curado en jugo de serrano-limón con pepino, cebolla morada y cilantro fresco' }, price: '$240', signature: true },
    { id: 9, name: { en: 'Black Aguachile', es: 'Aguachile Negro' }, description: { en: 'Shrimp in soy-based dark sauce with habanero, sesame, and micro greens', es: 'Camarón en salsa oscura a base de soya con habanero, ajonjolí y micro-greens' }, price: '$260', signature: false },
    { id: 10, name: { en: 'Red Aguachile', es: 'Aguachile Rojo' }, description: { en: 'Shrimp bathed in a fiery red chile de árbol sauce with mango and jicama', es: 'Camarón bañado en una ardiente salsa de chile de árbol con mango y jícama' }, price: '$250', signature: false },
  ],
  tostadas: [
    { id: 11, name: { en: 'Tuna Tostada', es: 'Tostada de Atún' }, description: { en: 'Seared ahi tuna on crispy corn tostada with chipotle aioli and pickled onions', es: 'Atún ahi sellado en tostada de maíz crujiente con aioli de chipotle y cebolla encurtida' }, price: '$180', signature: false },
    { id: 12, name: { en: 'Ceviche Tostada', es: 'Tostada de Ceviche' }, description: { en: 'Classic Sinaloa-style fish ceviche with tomato, onion, cilantro, and avocado', es: 'Ceviche clásico estilo Sinaloa con tomate, cebolla, cilantro y aguacate' }, price: '$160', signature: true },
    { id: 13, name: { en: 'Shrimp Tostada', es: 'Tostada de Camarón' }, description: { en: 'Seasoned grilled shrimp on tostada with guacamole and salsa macha drizzle', es: 'Camarón asado sazonado en tostada con guacamole y salsa macha' }, price: '$170', signature: false },
  ],
  specials: [
    { id: 14, name: { en: 'Marlin Tacos (3 pcs)', es: 'Tacos de Marlín (3 pzas)' }, description: { en: 'Smoked marlin with chipotle sauce, cabbage slaw, and handmade corn tortillas', es: 'Marlín ahumado con salsa chipotle, ensalada de col y tortillas de maíz hechas a mano' }, price: '$200', signature: false },
    { id: 15, name: { en: 'Seafood Molcajete', es: 'Molcajete de Mariscos' }, description: { en: 'A sizzling stone mortar filled with shrimp, octopus, fish, and our signature red salsa', es: 'Molcajete ardiente con camarón, pulpo, pescado y nuestra salsa roja insignia' }, price: '$450', signature: true },
    { id: 16, name: { en: 'Coconut Shrimp', es: 'Camarón al Coco' }, description: { en: 'Crispy coconut-crusted jumbo shrimp with mango-habanero dipping sauce', es: 'Camarón jumbo empanizado en coco crujiente con salsa de mango-habanero' }, price: '$280', signature: false },
  ],
};

export const galleryImages = [
  { id: 1, src: '/assets/images/gallery/gallery-01.jpg', alt: { en: 'Owner welcoming guests at Cristian\'s Baja Salada Los Cabos', es: 'Dueño dando la bienvenida en Cristian\'s Baja Salada Los Cabos' }, category: 'interior' },
  { id: 2, src: '/assets/images/gallery/gallery-02.jpg', alt: { en: 'Cristian\'s Baja Salada restaurant exterior Puro Pata Salada Los Cabos', es: 'Exterior del restaurante Cristian\'s Baja Salada Puro Pata Salada Los Cabos' }, category: 'exterior' },
  { id: 3, src: '/assets/images/gallery/gallery-03.jpg', alt: { en: 'Fresh sushi roll with signature sauce at best mariscos Los Cabos', es: 'Rollo de sushi fresco con salsa especial en mejor mariscos Los Cabos' }, category: 'food' },
  { id: 4, src: '/assets/images/gallery/gallery-04.jpg', alt: { en: 'Tuna tartare tower with avocado and crispy chips Los Cabos', es: 'Torre de tartara de atún con aguacate y chips crujientes Los Cabos' }, category: 'food' },
  { id: 5, src: '/assets/images/gallery/gallery-05.jpg', alt: { en: 'Seafood platter with octopus shrimp and local Baja beers Cabo San Lucas', es: 'Platillo de mariscos con pulpo camarón y cervezas locales de Baja Cabo San Lucas' }, category: 'food' },
  { id: 6, src: '/assets/images/gallery/gallery-06.jpg', alt: { en: 'Friendly server with seafood platter at best mariscos restaurant Los Cabos', es: 'Mesero amable con platillo de mariscos en mejor restaurante de mariscos Los Cabos' }, category: 'service' },
  { id: 7, src: '/assets/images/gallery/gallery-07.jpg', alt: { en: 'Cristian\'s Baja Salada beach location Mariscos and Sushi Los Cabos', es: 'Cristian\'s Baja Salada ubicación de playa Mariscos y Sushi Los Cabos' }, category: 'exterior' },
  { id: 8, src: '/assets/images/gallery/gallery-08.jpg', alt: { en: 'Ocean view terrace table sunset dining Los Cabos seafood restaurant', es: 'Mesa en terraza con vista al mar y atardecer restaurante de mariscos Los Cabos' }, category: 'ambiance' },
  { id: 9, src: '/assets/images/gallery/gallery-09.jpg', alt: { en: 'Coffee drinks and shrimp appetizer at Cristian\'s Baja Salada', es: 'Bebidas de café y aperitivo de camarón en Cristian\'s Baja Salada' }, category: 'drinks' },
  { id: 10, src: '/assets/images/gallery/gallery-10.jpg', alt: { en: 'Baja fish tacos with cabbage slaw best seafood Los Cabos', es: 'Tacos de pescado Baja con ensalada de col mejor mariscos Los Cabos' }, category: 'food' },
  { id: 11, src: '/assets/images/gallery/gallery-11.jpg', alt: { en: 'Three ceviche varieties fresh Sinaloa style mariscos Los Cabos', es: 'Tres variedades de ceviche frescos estilo Sinaloa mariscos Los Cabos' }, category: 'food' },
  { id: 12, src: '/assets/images/gallery/gallery-12.jpg', alt: { en: 'Chef presenting signature tuna tartare tostadas Cristian\'s Baja Salada', es: 'Chef presentando tostadas de tartara de atún Cristian\'s Baja Salada' }, category: 'food' },
  { id: 13, src: '/assets/images/gallery/gallery-13.jpg', alt: { en: 'Green aguachile with fresh shrimp avocado and tuna best mariscos Cabo', es: 'Aguachile verde con camarón fresco aguacate y atún mejor mariscos Cabo' }, category: 'food' },
  { id: 14, src: '/assets/images/gallery/gallery-14.jpg', alt: { en: 'Cristian\'s Baja Salada official logo Mariscos Sushi Bar Los Cabos', es: 'Logo oficial Cristian\'s Baja Salada Mariscos Sushi Bar Los Cabos' }, category: 'branding' },
  { id: 15, src: '/assets/images/gallery/gallery-15.png', alt: { en: 'Carretera Transpeninsular location Ceviches y Aguachiles Estilo Pata Salada', es: 'Ubicación Carretera Transpeninsular Ceviches y Aguachiles Estilo Pata Salada' }, category: 'exterior' },
  { id: 16, src: '/assets/images/gallery/gallery-16.jpg', alt: { en: 'Cristian\'s Baja Salada team family photo holiday season Los Cabos', es: 'Foto familiar del equipo Cristian\'s Baja Salada temporada navideña Los Cabos' }, category: 'team' },
  { id: 17, src: '/assets/images/gallery/gallery-17.jpg', alt: { en: 'Spicy tuna sushi roll with jalapeños and eel sauce best sushi Los Cabos', es: 'Rollo de sushi de atún picante con jalapeños y salsa de anguila mejor sushi Los Cabos' }, category: 'food' },
  { id: 18, src: '/assets/images/gallery/gallery-19.png', alt: { en: 'I Love Baja Salada sign Mariscos 100% Sinaloenses sunset view Los Cabos', es: 'Letrero I Love Baja Salada Mariscos 100% Sinaloenses vista al atardecer Los Cabos' }, category: 'branding' },
];

export const reviewsData = [
  {
    id: 1,
    name: 'Sarah M.',
    rating: 5,
    date: '2025-07-15',
    text: { en: 'The best seafood I\'ve had in Los Cabos! The aguachile verde was incredible and the ocean view from the terrace made it even more special. Highly recommend for families!', es: '¡Los mejores mariscos que he probado en Los Cabos! El aguachile verde fue increíble y la vista al mar desde la terraza lo hizo aún más especial. ¡Muy recomendado para familias!' },
    source: 'google',
    avatar: 'SM',
  },
  {
    id: 2,
    name: 'Carlos R.',
    rating: 5,
    date: '2025-06-28',
    text: { en: 'Authentic Sinaloa flavors that remind me of home. The zarandeado fish was cooked to perfection. The staff was incredibly friendly and attentive. We\'ll be back!', es: 'Sabores auténticos de Sinaloa que me recuerdan a casa. El pescado zarandeado estaba cocinado a la perfección. El personal fue increíblemente amable y atento. ¡Regresaremos!' },
    source: 'google',
    avatar: 'CR',
  },
  {
    id: 3,
    name: 'Jennifer & Tom',
    rating: 5,
    date: '2025-07-02',
    text: { en: 'We visited both locations during our vacation. Outstanding food quality, beautiful ambiance, and the cocktails were amazing. A must-visit in Cabo!', es: 'Visitamos ambas ubicaciones durante nuestras vacaciones. Calidad de comida excepcional, ambiente hermoso y los cócteles estaban increíbles. ¡Un imperdible en Cabo!' },
    source: 'tripadvisor',
    avatar: 'JT',
  },
  {
    id: 4,
    name: 'María Elena G.',
    rating: 5,
    date: '2025-06-15',
    text: { en: 'The shrimp cocktail Sinaloa style is unlike anything else in town. Fresh ingredients, generous portions, and incredible flavors. The kids loved it too!', es: 'El cóctel de camarón estilo Sinaloa no se compara con nada en la ciudad. Ingredientes frescos, porciones generosas y sabores increíbles. ¡A los niños también les encantó!' },
    source: 'google',
    avatar: 'MG',
  },
  {
    id: 5,
    name: 'David L.',
    rating: 4,
    date: '2025-05-20',
    text: { en: 'Great food, great atmosphere. The Baja Roll sushi was a pleasant surprise — creative and delicious. The only reason for 4 stars is we had to wait a bit during peak hours.', es: 'Excelente comida, excelente ambiente. El rollo Baja de sushi fue una agradable sorpresa — creativo y delicioso. La única razón de las 4 estrellas es que tuvimos que esperar un poco en horas pico.' },
    source: 'tripadvisor',
    avatar: 'DL',
  },
  {
    id: 6,
    name: 'Ana Patricia',
    rating: 5,
    date: '2025-07-10',
    text: { en: 'This is our go-to spot every weekend. The seafood molcajete is absolutely divine. Love the modern vibe and family-friendly atmosphere. Best mariscos in Cabo, hands down!', es: '¡Este es nuestro lugar favorito cada fin de semana! El molcajete de mariscos es absolutamente divino. Me encanta el ambiente moderno y familiar. ¡Los mejores mariscos en Cabo, sin duda!' },
    source: 'google',
    avatar: 'AP',
  },
];

export const reviewLinks = {
  google: 'https://share.google/wQKgv90OD9H7Vdsi0',
  tripadvisor: 'https://www.tripadvisor.com.mx/Restaurant_Review-g152515-d28142957-Reviews-Cristian_s_Baja_Salada-Cabo_San_Lucas_Los_Cabos_Baja_California.html?m=69573',
};

export const socialLinks = {
  instagram: 'https://www.instagram.com/mariscosbajasalada/',
  facebook: 'https://www.facebook.com/mariscosbajasalada',
};

export const instagramPosts = [
  { id: 1, image: '/assets/images/gallery/gallery-03.jpg', likes: 342, comments: 28 },
  { id: 2, image: '/assets/images/gallery/gallery-04.jpg', likes: 518, comments: 45 },
  { id: 3, image: '/assets/images/gallery/gallery-05.jpg', likes: 289, comments: 19 },
  { id: 4, image: '/assets/images/gallery/gallery-01.jpg', likes: 467, comments: 37 },
  { id: 5, image: '/assets/images/gallery/gallery-02.jpg', likes: 391, comments: 32 },
  { id: 6, image: '/assets/images/gallery/gallery-03.jpg', likes: 623, comments: 51 },
];
